var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('formBox',{ref:"formBoxRef",model:{value:(_vm.params),callback:function ($$v) {_vm.params=$$v},expression:"params"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }